import VueCookies from 'vue-cookies';
import store from "../store";
import { IS_USER_AUTHENTICATED, GET_SELLER } from "../store/auth/const";
import router from '../router';
export default class userInfo {

    getIsLogged() {
        const stateLogged = store.getters[`auth/${IS_USER_AUTHENTICATED}`];
        if (stateLogged !== 'undefined') {
            VueCookies.set('seller_logged', stateLogged);
        }
        const cookieLogged = VueCookies.isKey('seller_logged') ? VueCookies.get('seller_logged') : false;
        if (cookieLogged) {
            return true;
        }
        router.push('/signin');
    }

    getSeller() {
        
        const stateSeller = store.getters[`auth/${GET_SELLER}`];
        if (Object.keys(stateSeller).length) {
            VueCookies.set('seller', stateSeller);
        }
        const cookieSeller = VueCookies.isKey('seller') ? VueCookies.get('seller') : false;
        if (cookieSeller && this.getIsLogged()) {
            return cookieSeller;
        }

        return {};
    }
    
}